import { Player, Team, Host_Event_Name } from '@quiz-buzz/common'
import { useSelector } from '@xstate/react'
import { style } from 'typestyle'
import { host_machine_actor } from '../App/main'

export function Host_In_Game_Players_And_Teams_Content() {

    const { 
        teams_enabled, 
        teams, 
        whos_buzzer_is_active, 
        players 
    } = useSelector(host_machine_actor, (state) => state.context)
    

	const modify_team_score = (team: Team, diff: number) =>
		host_machine_actor.send({
			type: Host_Event_Name.change_team_score,
			detail: {
				team_name: team.name,
				score_diff: team.score + diff,
			},
		})
        
	const modify_player_score = (player: Player, diff: number) =>
		host_machine_actor.send({
			type: Host_Event_Name.change_player_score,
			detail: {
				player_name: player.name,
				score_diff: player.score + diff,
			},
		})

    return <>
        {teams_enabled && teams.map((team, i) => (
            <div data-testId={`team row ${team.name}`} className={team_container_style}>
                <div className={team_left_side_style}>
                    <div className={host_team_name_style}>{team.name}</div>
                    <div>
                        <div className="score_buttons">
                            <div>
                                <button
                                    className={score_button_style}
                                    data-testId={`team_score_plus_1_${i}`}
                                    onClick={() => modify_team_score(team, 1)}>
                                    +1
                                </button>
                                <button
                                    className={score_button_style}
                                    data-testId={`team_score_plus_5_${i}`}
                                    onClick={() => modify_team_score(team, 5)}>
                                    +5
                                </button>
                            </div>
                            <div>
                                <button
                                    className={score_button_style}
                                    data-testId={`team_score_minus_1_${i}`}
                                    onClick={() => modify_team_score(team, -1)}>
                                    -1
                                </button>
                                <button
                                    className={score_button_style}
                                    data-testId={`team_score_minus_5_${i}`}
                                    onClick={() => modify_team_score(team, -5)}>
                                    -5
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={team_center_style}>
                    <div>Score:</div>
                    <div data-testId={`team_score_${i}`} className={score_box_style}>
                        {team.score}
                    </div>
                </div>
                <div className="team_right_side">
                    <div>Team members:</div>
                    <div className="team_players_box">
                        {team.members.map(member_name => (
                            <div
                                className={`${player_item_style} ${
                                    whos_buzzer_is_active === member_name ? player_item_buzzed_style : ''
                                }`}>
                                {member_name}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        ))}

        {!teams_enabled && (
            <>
                <table className={host_in_game_player_list_style}>
                    <thead>
                        <tr>
                            <th>Player</th>
                            <th>Score</th>
                            <th></th>
                            <th>Points</th>
                        </tr>
                    </thead>
                    {players.length === 0 && (
                        <tr>
                            <td colSpan={3}></td>
                        </tr>
                    )}
                    <tbody>
                        {players.map((player, i) => (
                            <tr>
                                <td>
                                    <div className={player_item_style} data-player-item={player.name}>
                                        {player.name}
                                    </div>
                                </td>
                                <td
                                    data-testId={`player_score_${i}`}
                                    className={player_score_style}>
                                    {player.score}
                                </td>
                                <td>
                                    <div
                                        data-testId={`player_connected_${i}`}
                                        className={
                                            player.connected
                                                ? 'socket_connected'
                                                : 'socket_disconnected'
                                        }></div>
                                </td>
                                <td>
                                    <button
                                        data-testId={`player_neg_button_${i}`}
                                        className="negative"
                                        onClick={() => modify_player_score(player, -5)}>
                                        -5
                                    </button>
                                    <button
                                        data-testId={`player_pos_button_${i}`}
                                        onClick={() => modify_player_score(player, +5)}>
                                        +5
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
        )}
    </>
}

const host_team_name_style = style({
	fontSize: '1.5em',
	maxWidth: '5em',
	textOverflow: 'ellipsis',
    overflow: 'hidden',
	paddingRight: '0.3em',
})

export const team_container_style = style({
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: '8em',
    backgroundColor: '#b5b5b5cc',
    padding: '0.2em',
    border: '1px solid white',
    marginBottom: '0.2em',
})

const team_center_style = style({
	flex: '1',
	maxWidth: '7em',
    minWidth: '6em',
})


const team_left_side_style = style({
    minWidth: '5em',
})

const player_item_style = style({
	transition: 'backgroundColor 0.2s',
})

const player_item_buzzed_style = style({
	backgroundColor: '#ff4e8c',
	transition: 'background-color 0s',
})

const score_box_style = style({
	fontSize: '5em',
})

const player_score_style = style ({
	fontSize: '2em',
})

const score_button_style = style({
	width: '2em',
	height: 'auto',
	padding: '0.2em 0',
	marginRight: '0.4em',
}) 


const host_in_game_player_list_style = style({
	backgroundColor: '#0003',
    $nest: {
        thead: {
            backgroundColor: '#5553',
            height: '2.3em',
        },
        th: {
            backgroundColor: '#5553',
            height: '2.3em',
            textAlign: 'left',
            padding: '0.2em',
        },
        td: {
            padding: '0.2em',
        },
        'th:nth-child(1)': {
            width: '40%',
        },
        'th:nth-child(2)': {
            width: '20%',
        },
        'th:nth-child(3)': {
            width: '10%',
        },
        'th:nth-child(4)': {
            width: '30%',
        },
    }
})
